<input
   #input
   type="text"
   [placeholder]="placeHolder"
   [value]="controlDir.control.value"
   (input)="onChange($event.target.value)"
   (blur)="onTouched()"
   [disabled]="disabled"
/>

<span
   class="feedback danger"
   role="alert"
   *ngIf="controlDir && !controlDir.control.valid && controlDir.control.touched"
>
   <i class="fas fa-times-circle" aria-hidden="true"></i>

   <span *ngIf="controlDir.control.errors?.required">
      O preenchimento desse campo é obrigatório.
   </span>
   <span *ngIf="controlDir.control.errors?.maxlength">
      A quantidade de caracteres inseridos excede o limite de
      {{ controlDir.control.errors?.maxlength.requiredLength }}.
   </span>
   <span *ngIf="controlDir.control.errors?.pattern"
      >Por favor insira um E-mail válido.</span
   >
</span>
